import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header__title" }
const _hoisted_4 = { class: "header__description" }
const _hoisted_5 = { class: "input-field__title__container" }
const _hoisted_6 = { class: "input-field__title" }
const _hoisted_7 = { class: "input-field-content" }
const _hoisted_8 = {
  key: 0,
  class: "input-field-content__container"
}
const _hoisted_9 = { class: "input-field-content__label" }
const _hoisted_10 = {
  key: 0,
  class: "calendar__icon__container"
}
const _hoisted_11 = {
  key: 1,
  class: "calendar__text__container"
}
const _hoisted_12 = { class: "calendar__text" }
const _hoisted_13 = { class: "input-field-content__container" }
const _hoisted_14 = { class: "input-field-content__label" }
const _hoisted_15 = { class: "input-field-content__container" }
const _hoisted_16 = { class: "input-field-content__label" }
const _hoisted_17 = { class: "input-field-content--checkbox" }
const _hoisted_18 = { class: "content-desc" }
const _hoisted_19 = { class: "content-desc__title" }
const _hoisted_20 = { class: "content-desc__text" }
const _hoisted_21 = { class: "footer" }
const _hoisted_22 = {
  key: 0,
  class: "button-container"
}
const _hoisted_23 = {
  key: 1,
  class: "button-container"
}

import Modal from '@/components/modal/Modal.vue';
import VueDatePicker from '@vuepic/vue-datepicker';
import { FieldItem, ValidateRule } from '@/coreDomainsModule/constant/validateRules';
import NumberInputWithComma from '@/corePagesModule/components/NumberInputWithComma.vue';
import { useForms } from '@/corePagesModule/composables/useForm';
import { i18n } from '@/i18n';
import Button from '@/components/input/Btn/Btn.vue';
import { computed, ref, watch } from 'vue';
import { loadMyPropertyPreferences, myPropertyPreferences, saveMyPropertyPreferences } from '@/appLogic/view/preferences';
import { IDate } from '@/coreDomainsModule/date';
import { DateService } from '@/coreDomainsModule/services/dateService';
import Mdi from '@/corePagesModule/components/Mdi.vue';
import { CombinedOrderSettingModalStatus, ICombinedOrderConditions } from '@/InventoryControlModule/domains/entities/CombinedOrder';
import RowCheckBox from '@/components/atom/RowCheckBox.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CombinedOrderSettingModal',
  props: {
    modalState: {},
    defaultDesiredDeliveryDate: { default: null }
  },
  emits: ["close", "confirm"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "04149c16": (inputFieldGridTemplate.value)
}))

const t = i18n.t;

const INPUT_FIELD_LIST = [
  { priority: 1, prefix: 'primary' },
  { priority: 2, prefix: 'secondary' },
] as const;

const props = __props;

const emits = __emit;

const fieldItems: FieldItem[] = [
  {
    name: 'primaryTotalOrderAmount',
    rules: [ValidateRule.Required, ValidateRule.HalfWidthRealNumber, ValidateRule.NegativeNumber],
  },
  {
    name: 'primaryTurnOverUpperLimit',
    rules: [ValidateRule.Required, ValidateRule.HalfWidthRealNumber],
  },
  {
    name: 'secondaryTotalOrderAmount',
    rules: [ValidateRule.Required, ValidateRule.HalfWidthRealNumber, ValidateRule.NegativeNumber],
  },
  {
    name: 'secondaryTurnOverUpperLimit',
    rules: [ValidateRule.Required, ValidateRule.HalfWidthRealNumber],
  },
];

const { fieldState, allValidate, resetForm } = useForms(fieldItems);

const desiredDeliveryDate = ref<{ primary: IDate | null; secondary: IDate | null }>({ primary: null, secondary: null });

const isMOQConsidered = ref<{ primary: boolean; secondary: boolean }>({ primary: true, secondary: true });

const modalState = computed(() => props.modalState !== 'close');

const isDefaultSetting = computed(() => props.modalState === 'setting');

const isErrorDesiredDeliveryDate = computed(() => ({
  primary:
    desiredDeliveryDate.value.primary === null ||
    DateService.compareDates(desiredDeliveryDate.value.primary, DateService.convertDateToIDate(new Date())) === -1,
  secondary:
    desiredDeliveryDate.value.secondary === null ||
    DateService.compareDates(desiredDeliveryDate.value.secondary, DateService.convertDateToIDate(new Date())) === -1,
}));

const isErrorWithPrefix = computed(() => ({
  primary:
    fieldState['primaryTotalOrderAmount'].isError.value ||
    fieldState['primaryTurnOverUpperLimit'].isError.value ||
    (props.modalState === 'generate' && isErrorDesiredDeliveryDate.value.primary),
  secondary:
    fieldState['secondaryTotalOrderAmount'].isError.value ||
    fieldState['secondaryTurnOverUpperLimit'].isError.value ||
    (props.modalState === 'generate' && isErrorDesiredDeliveryDate.value.secondary),
}));

const inputFieldGridTemplate = computed(() => (isDefaultSetting.value ? '1fr 1fr' : '1fr 1fr 1fr'));

const modalTitle = computed(() => t(isDefaultSetting.value ? 'まとめ発注デフォルト設定' : 'まとめ発注案の生成'));

const confirmButtonText = computed(() => (props.modalState === 'progress' ? 'まとめ発注の案を生成中...' : 'まとめ発注の案を生成'));

/**
 * desiredDeliveryDateの値をリセットする
 */
const resetdesiredDeliveryDateValue = () => {
  desiredDeliveryDate.value = { primary: null, secondary: null };
};

/**
 * inputの値が変更された際のハンドラ
 * @param inputNamePrefix - 変更したinputが 'primary' | 'secondary' のどちらか
 * @param inputType - 変更したinputの種類
 * @param value - 変更された値
 */
const onInputHandler = (inputNamePrefix: 'primary' | 'secondary', inputType: 'TotalOrderAmount' | 'TurnOverUpperLimit', value: number) => {
  // それぞれ合計発注数量は整数に、上限在庫回転率は第1桁で切り捨てたものを文字列にしてfieldStateに保存
  fieldState[inputNamePrefix + inputType].setValue(
    inputType === 'TotalOrderAmount' ? Math.floor(value).toString() : (Math.floor(value * 10) / 10).toString()
  );
};

/**
 * desiredDeliveryDateの値が変更された際のハンドラ
 * @param inputNamePrefix - 変更したinputが 'primary' | 'secondary' のどちらか
 * @param value - 変更された値
 */
const onInputDesiredDeliveryDateHandler = (inputNamePrefix: 'primary' | 'secondary', value: Date) => {
  if (desiredDeliveryDate.value.primary === null && desiredDeliveryDate.value.secondary === null) {
    desiredDeliveryDate.value.primary = DateService.convertDateToIDate(value);
    desiredDeliveryDate.value.secondary = DateService.convertDateToIDate(value);
  } else {
    desiredDeliveryDate.value[inputNamePrefix] = DateService.convertDateToIDate(value);
  }
};

/**
 * 戻るボタンクリック時の処理
 */
const handleBack = () => {
  if (props.modalState) {
    resetForm(fieldItems);
    resetdesiredDeliveryDateValue();
    emits('close');
  }
};

/**
 * 設定ボタンクリック時の処理
 */
const handleNextSetting = async () => {
  if (!allValidate()) {
    return;
  }
  await saveCondition();
  emits('close');
};

/**
 * まとめ発注生成ボタンクリック時の処理
 */
const handleNextConfirm = async () => {
  if (!allValidate() || !desiredDeliveryDate.value.primary || !desiredDeliveryDate.value.secondary) {
    return;
  }
  emits('confirm', {
    primary: {
      totalOrderAmount: Number(fieldState['primaryTotalOrderAmount'].value.value),
      turnOverUpperLimit: Number(fieldState['primaryTurnOverUpperLimit'].value.value),
      desiredDeliveryDate: desiredDeliveryDate.value.primary,
      isMOQConsidered: isMOQConsidered.value.primary,
    },
    secondary: {
      totalOrderAmount: Number(fieldState['secondaryTotalOrderAmount'].value.value),
      turnOverUpperLimit: Number(fieldState['secondaryTurnOverUpperLimit'].value.value),
      desiredDeliveryDate: desiredDeliveryDate.value.secondary,
      isMOQConsidered: isMOQConsidered.value.secondary,
    },
  });
};

/**
 * まとめ発注デフォルト設定をIndexedDBに保存する
 */
const saveCondition = async () => {
  myPropertyPreferences.order.combineOrderDefaultCond = {
    primary: {
      totalOrderAmount: Number(fieldState['primaryTotalOrderAmount'].value.value),
      turnOverUpperLimit: Number(fieldState['primaryTurnOverUpperLimit'].value.value),
      isMOQConsidered: isMOQConsidered.value.primary,
    },
    secondary: {
      totalOrderAmount: Number(fieldState['secondaryTotalOrderAmount'].value.value),
      turnOverUpperLimit: Number(fieldState['secondaryTurnOverUpperLimit'].value.value),
      isMOQConsidered: isMOQConsidered.value.secondary,
    },
  };
  await saveMyPropertyPreferences();
};

watch(
  () => props.modalState,
  async (value) => {
    if (value === 'close' || value === 'progress') return;
    await loadMyPropertyPreferences();
    const combineOrderDefaultCondData = myPropertyPreferences.order.combineOrderDefaultCond;
    if (!combineOrderDefaultCondData || !fieldState) return;
    for (const inputField of INPUT_FIELD_LIST) {
      fieldState[inputField.prefix + 'TotalOrderAmount'].value.value =
        combineOrderDefaultCondData[inputField.prefix].totalOrderAmount.toString();
      fieldState[inputField.prefix + 'TurnOverUpperLimit'].value.value =
        combineOrderDefaultCondData[inputField.prefix].turnOverUpperLimit.toString();
      isMOQConsidered.value[inputField.prefix] = combineOrderDefaultCondData[inputField.prefix].isMOQConsidered;
    }
    if (value === 'generate' && props.defaultDesiredDeliveryDate !== null) {
      desiredDeliveryDate.value.primary = props.defaultDesiredDeliveryDate;
      desiredDeliveryDate.value.secondary = props.defaultDesiredDeliveryDate;
    } else {
      resetdesiredDeliveryDateValue();
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    "modal-state": modalState.value,
    padding: "0",
    "border-radius": "16px",
    "no-padding-and-margin": false,
    "modal-size": "max-content",
    "is-force-no-style": true,
    "modal-width": 580,
    "md-click-out-side-to-close": "",
    "scroll-off": "",
    "no-cancel": "",
    "is-modal-overflow-hidden": "",
    onOutsideClick: handleBack
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(modalTitle.value), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('優先順位1で計算後、平均回転率が上限を超える場合は優先順位2を使用')), 1)
        ]),
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(INPUT_FIELD_LIST, (inputField) => {
          return _createElementVNode("div", {
            key: inputField.priority,
            class: _normalizeClass(["input-field", 'input-field--' + inputField.prefix])
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('優先順位') + inputField.priority), 1),
              _withDirectives(_createElementVNode("div", { class: "input-field__title__error" }, _toDisplayString(_unref(t)('正しい値を入力してください')), 513), [
                [_vShow, isErrorWithPrefix.value[inputField.prefix]]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              (!isDefaultSetting.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('希望納期') + '*'), 1),
                    _createVNode(_unref(VueDatePicker), {
                      "model-value": 
                  desiredDeliveryDate.value[inputField.prefix] &&
                  _unref(DateService).convertIDateToDate(desiredDeliveryDate.value[inputField.prefix] ?? { year: 9999, month: 99, day: 99 })
                ,
                      class: _normalizeClass(["calendar", { 'error-border': isErrorDesiredDeliveryDate.value[inputField.prefix] }]),
                      "mode-height": 1,
                      "enable-time-picker": false,
                      "month-change-on-scroll": false,
                      teleport: true,
                      format: "yyyy/MM/dd",
                      "week-start": "0",
                      "min-date": "today",
                      locale: _unref(i18n).locale,
                      "select-text": _unref(t)('選択'),
                      "cancel-text": _unref(t)('キャンセル'),
                      "show-now-button": true,
                      clearable: false,
                      "onUpdate:modelValue": ($event: any) => (onInputDesiredDeliveryDateHandler(inputField.prefix, $event))
                    }, {
                      "dp-input": _withCtx(({ isMenuOpen }) => [
                        (!desiredDeliveryDate.value[inputField.prefix])
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createVNode(Mdi, {
                                class: "calendar__icon",
                                icon: "calendar_today"
                              })
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(DateService).convertIYearMonthDayToYYYYMMDDWithSlash(
                          desiredDeliveryDate.value[inputField.prefix] ?? { year: 9999, month: 99, day: 99 },
                          true
                        )), 1),
                              _createVNode(Mdi, {
                                class: "calendar__icon",
                                icon: isMenuOpen ? 'expand_less' : 'expand_more'
                              }, null, 8, ["icon"])
                            ]))
                      ]),
                      _: 2
                    }, 1032, ["model-value", "class", "locale", "select-text", "cancel-text", "onUpdate:modelValue"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(t)('合計発注数量') + '*'), 1),
                _createVNode(NumberInputWithComma, {
                  "model-value": Number(_unref(fieldState)[inputField.prefix + 'TotalOrderAmount'].value.value),
                  class: _normalizeClass(["input-field-content__input", { 'error-border': _unref(fieldState)[inputField.prefix + 'TotalOrderAmount'].isError.value }]),
                  onInput: (e) => onInputHandler(inputField.prefix, 'TotalOrderAmount', e)
                }, null, 8, ["model-value", "class", "onInput"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(t)('上限在庫回転率') + '*'), 1),
                _createVNode(NumberInputWithComma, {
                  "model-value": Number(_unref(fieldState)[inputField.prefix + 'TurnOverUpperLimit'].value.value),
                  class: _normalizeClass(["input-field-content__input", { 'error-border': _unref(fieldState)[inputField.prefix + 'TurnOverUpperLimit'].isError.value }]),
                  onInput: (e) => onInputHandler(inputField.prefix, 'TurnOverUpperLimit', e)
                }, null, 8, ["model-value", "class", "onInput"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(RowCheckBox, {
                  "is-checked": isMOQConsidered.value[inputField.prefix],
                  "label-text": _unref(t)('必ずMOQを満たすように発注案を生成する'),
                  class: "moq-checkbox",
                  onChangeStatus: (value) => (isMOQConsidered.value[inputField.prefix] = value)
                }, null, 8, ["is-checked", "label-text", "onChangeStatus"])
              ])
            ])
          ], 2)
        }), 64)),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(t)('配分ロジック')), 1),
          _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(t)('1. 優先順位1で在庫回転率が平均的になるように配分を計算') + '\n') + " " + _toDisplayString(_unref(t)('2. 平均回転率が上限を超える場合は優先順位2で再計算') + '\n') + " " + _toDisplayString(_unref(t)('3. 在庫回転率が低い商品に優先的に配分') + '\n'), 1)
        ]),
        _createElementVNode("div", _hoisted_21, [
          (isDefaultSetting.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createVNode(Button, {
                  class: "button button--cancel",
                  onClick: handleBack
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('戻る')), 1)
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(Button, {
                  class: "button button--save",
                  onClick: handleNextSetting
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('設定')), 1)
                  ], undefined, true),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createVNode(Button, {
                  class: "button button--save",
                  onClick: handleNextConfirm
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)(confirmButtonText.value)), 1)
                  ], undefined, true),
                  _: 1
                })
              ]))
        ])
      ])
    ], undefined, true),
    _: 1
  }, 8, ["modal-state"]))
}
}

})